import { useMemo } from 'react';
import moment from 'moment';
import classnames from 'classnames';
import Calendar from 'react-calendar';
import i18n from '@/i18n';
import { prettyDate } from '@/helpers/date';
import { DATE_REQUEST } from '@/helpers/common';
import IconPrev from './assets/icon_prev_double.svg';
import IconNext from './assets/icon_next_double.svg';
import s from './index.module.scss';

export const MonthRangeCalendar = ({ range, onRangeChange, minDate, maxDate }) => {
  const handleChange = val => {
    if (Array.isArray(val)) {
      const [start, end] = val;
      if (start && end) {
        onRangeChange([
          prettyDate(start, DATE_REQUEST),
          moment(end).endOf('month').format(DATE_REQUEST),
        ]);
      }
    }
  };

  const sameMonth = useMemo(() => {
    if (
      range[0] &&
      range[1] &&
      moment(range[0]).format('YYYY-MM') === moment(range[1]).format('YYYY-MM')
    ) {
      return true;
    }
    return false;
  }, [range]);

  return (
    <Calendar
      className={classnames(s.calendar, sameMonth && s.calendar_same_month)}
      selectRange
      defaultView="year"
      maxDetail="year"
      minDetail="year"
      minDate={minDate}
      maxDate={maxDate}
      locale={i18n.language}
      onChange={handleChange}
      value={range}
      nextLabel={<img src={IconNext} alt="next" width={16} height={16} />}
      prevLabel={<img src={IconPrev} alt="prev" width={16} height={16} />}
      returnValue="range"
    />
  );
};
